class YandexMetrika {
	constructor() {
	}

	goal(goal) {
		if (typeof window['yaCounter' + App.ymId] !== 'undefined') {
			console.log('Worked goal [OK]: ' + goal);
			window['yaCounter' + App.ymId].reachGoal(goal);
		} else {
			console.log('Call goal [BAD]: ' + goal);
		}
	}

	hit(hit = null) {
		hit = hit || location.href;

		if (typeof window['yaCounter' + App.ymId] !== 'undefined') {
			console.log('Worked hit: ' + hit);
			window['yaCounter' + App.ymId].hit(hit);
		} else {
			console.log('Call hit [BAD]: ' + hit);
		}
	}
}

export default YandexMetrika;
